import React, { useEffect, useState } from 'react';

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

import styles from './MediaType.module.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      display: false
    },
    title: {
      display: false,
      text: '',
    },
  },
};

// const labels = ['Pencil', 'Pen', 'Wash', 'Color', 'Paint'];

const tempMD = [
  {
      "media": "pencil",
      "count": 58
  },
  {
      "media": "pen",
      "count": 17
  },
  {
      "media": "color",
      "count": 9
  },
  {
      "media": "wash",
      "count": 6
  },
  {
    "media": "paint",
    "count": 2
}
];

const tempMD2 = [
  58,
  17,
  9,
  6,
  2
]

const MediaDoughnut = (props) => {
  const [mediaTypes, setMediaTypes] = useState(tempMD2);

  // console.log('check', tempMD.map(e => e.count));

  let data = {
    labels: tempMD.map(e => e.media),
    datasets: [
      {
        label: '# of Votes',
        data: tempMD.map(e => e.count),
        backgroundColor: ['#5D534A',
        '#2F5D62',
        '#BB371A',
        '#EBA83A',
        '#5E8B7E'
        ],
        borderColor: [
          '#5D534A',
        '#2F5D62',
        '#BB371A',
        '#EBA83A',
        '#5E8B7E',
        ],
        borderWidth: 1,
      },
    ],
  };

  useEffect(() => {
    setMediaTypes(props.mediaTypeArray.map(e => e.count));
    // console.log('props.mediaTypeArray', props.mediaTypeArray);
  }, [props.mediaTypeArray]);

  data = {
    labels: props.mediaTypeArray.map(e => e.media),
    datasets: [
      {
        label: '# of Votes',
        data: props.mediaTypeArray.map(e => e.count),
        backgroundColor: ['#5D534A',
        '#0A81AB',
        '#BB371A',
        '#EBA83A',
        '#8B5E83'
        ],
        borderColor: [
          '#5D534A',
        '#0A81AB',
        '#BB371A',
        '#EBA83A',
        '#8B5E83',
        ],
        borderWidth: 1,
      },
    ],
  };

  // data = {
  //   labels,
  //   datasets: [
  //     {
  //       label: '',
  //       data: props.mediaTypeArray.map(e => e.count),
  //       backgroundColor: ['#5D534A',
  //       '#2F5D62',
  //       '#5E8B7E',
  //       '#EBA83A',
  //       '#BB371A'],
  //     }
  //   ],
  // };

  return (
    <div className={styles.categoriesContainer}>
      <div className={styles.pieDiv}>
        <Doughnut data={data} options={options} />
      </div>
    </div>
    
  );
};

export default MediaDoughnut;
